<aca-page-layout [hasError]="!isValidPath">
  <aca-page-layout-header>
    <adf-breadcrumb
      [root]="title"
      [folderNode]="node"
      [maxItems]="isSmallScreen ? 1 : 0"
      (navigate)="onBreadcrumbNavigate($event)"
    >
    </adf-breadcrumb>

    <aca-toolbar [items]="actions" />
  </aca-page-layout-header>

  <aca-page-layout-content>
    <div class="main-content">
      <adf-upload-drag-area
        (beginUpload)="onBeginUpload($event)"
        [rootFolderId]="node?.id"
        [disabled]="!canUpload"
        (updateFileVersion)="onUploadNewVersion($event)"
      >
        <wk-document-list
          #wkDocumentListRef
          acaWkDocumentList
          acaContextActions
          [rowFilter]="folderFilter"
          [display]="documentDisplayMode$ | async"
          selectionMode="multiple"
          [currentFolderId]="node?.id"
          [showHeader]="showHeader"
          [node]="nodeResult"
          [allowDropFiles]="true"
          [navigate]="false"
          [sorting]="['name', 'ASC']"
          [imageResolver]="imageResolveFunction"
          [headerFilters]="false"
          [filterValue]="queryParams"
          (node-dblclick)="customNavigateTo($event)"
          (name-click)="customNavigateTo($event)"
          (sorting-changed)="onSortingChanged($event)"
          (filterSelection)="onFilterSelected($event)"
        >
          <data-columns>
            <ng-container *ngFor="let column of columns; trackBy: trackById">
              <ng-container
                *ngIf="
                  column.template && !(column.desktopOnly && isSmallScreen)
                "
              >
                <data-column
                  [key]="column.key"
                  [title]="column.title"
                  [type]="column.type"
                  [format]="column.format"
                  [class]="column.class"
                  [sortable]="column.sortable"
                  [sortingKey]="column.sortingKey || column.key"
                >
                  <ng-template let-context>
                    <adf-dynamic-column
                      [id]="column.template"
                      [context]="context"
                    >
                    </adf-dynamic-column>
                  </ng-template>
                </data-column>
              </ng-container>

              <ng-container
                *ngIf="
                  !column.template && !(column.desktopOnly && isSmallScreen)
                "
              >
                <data-column
                  [key]="column.key"
                  [title]="column.title"
                  [type]="column.type"
                  [format]="column.format"
                  [class]="column.class"
                  [sortable]="column.sortable"
                  [sortingKey]="column.sortingKey || column.key"
                >
                </data-column>
              </ng-container>
            </ng-container>
          </data-columns>

          <adf-custom-empty-content-template *ngIf="isFilterHeaderActive()">
            <ng-container>
              <div class="empty-search__block">
                <p class="empty-search__text">
                  {{ 'APP.BROWSE.SEARCH.NO_FILTER_RESULTS' | translate }}
                </p>
              </div>
            </ng-container>
          </adf-custom-empty-content-template>
        </wk-document-list>

        <adf-pagination acaPagination [target]="wkDocumentListRef">
        </adf-pagination>
      </adf-upload-drag-area>
    </div>
    <div class="sidebar" *ngIf="infoDrawerOpened$ | async">
      <adf-dynamic-component [id]="infoDrawerComponentId">
      </adf-dynamic-component>
    </div>
  </aca-page-layout-content>
  <aca-page-layout-error>
    <aca-generic-error></aca-generic-error>
  </aca-page-layout-error>
</aca-page-layout>
